export var QuestionReportTab;

(function (QuestionReportTab) {
  QuestionReportTab["Detail"] = "detail";
  QuestionReportTab["Bookmark"] = "bookmark";
})(QuestionReportTab || (QuestionReportTab = {}));